export enum FileTypeName {
  Unknown = 'Unknown',
  AdditionalDocument = 'AdditionalDocument',
  AdditionalInformation = 'AdditionalInformation',
  BrokerageAgreementApplication = 'BrokerageAgreementApplication',
  IncomeSource = 'IncomeSource',
  OpenSubAccountOrder = 'OpenSubAccountOrder',
  ProofOfResidence = 'ProofOfResidence',
  Selfie = 'Selfie',
  SignaturesCard = 'SignaturesCard',
  SignedBrokerageAgreementApplication = 'SignedBrokerageAgreementApplication',
  SignedOpenSubAccountOrder_Finance = 'SignedOpenSubAccountOrder_Finance',
  SignedApplicationStandardAgreement_Finance = 'SignedApplicationStandardAgreement_Finance',
  TaxResidence = 'TaxResidence',
  ClientServiceAgreement = 'ClientServiceAgreement',
  W8BENForm = 'W8BENForm',
  WithdrawalAccountOwnerConfirmation = 'WithdrawalAccountOwnerConfirmation',
  Questionnaire = 'Questionnaire',
  SignedQuestionnaire = 'SignedQuestionnaire',
  ClientSignedClientServiceAgreement = 'ClientSignedClientServiceAgreement',
  CompanySignedClientServiceAgreement_Global = 'CompanySignedClientServiceAgreement_Global',
  FullySignedClientServiceAgreement = 'FullySignedClientServiceAgreement',
  CompanySignedNoticeOfInvestmentAccountOpening = 'CompanySignedNoticeOfInvestmentAccountOpening',
  ClientQuestionnaire = 'ClientQuestionnaire',
  IdentityDocument = 'IdentityDocument',
  DocumentGroups = 'DocumentGroups',
  Invoice = 'Invoice',
  InvoicePaymentConfirmation = 'InvoicePaymentConfirmation',
  ConstitutionalDocument = 'ConstitutionalDocument',
  OwnershipStructure = 'OwnershipStructure',
  CompanySignedAgreement_Finance = 'CompanySignedAgreement_Finance',
}
export interface FileEntity {
  id: string;
  name: string;
  size: number;
  createdAt: Date;
  uploadedByAdmin?: boolean;
  type?: FileTypeName;
}
